import { Injectable } from "@angular/core";
import {
  HttpInterceptor,
  HttpHandler,
  HttpRequest,
} from "@angular/common/http";
import { OidcClientService } from "@upmc-healthplan-npm/oidc-client";

@Injectable()
export class AuthorizationInterceptor implements HttpInterceptor {
  isUpdating = false; // prevents simultaneous token update requests

  constructor(private auth: OidcClientService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler) {
    const user = this.auth.getUser();
    if (!user || this.auth.isExpired()) {
      this.auth.signIn();
    }
    if (this.auth.isExpiring() && !this.isUpdating) {
      this.isUpdating = true;
      this.auth.renewToken().subscribe(() => {
        this.isUpdating = false;
      });
    }
    const token = user.id_token;
    console.log("token", token);
    const newReq = req.clone({
      setHeaders: { Authorization: `Bearer ${token}` },
    });
    return next.handle(newReq);
  }
}
